module.exports = __webpack_public_path__ + "static/img/10.1a0acdf5.png";